import http from '@/services/http'
import { stockUrl } from '@/services/url'
import type * as Types from './type'
import { businessTimezoneTranslate } from '../businessTimezone'

/** 库存调整详情 */
export const getStockAdjustDetail = businessTimezoneTranslate(async (data) => http.admin.post('/api/stock-adjust/detail', data), [], ['data.adjustTime'])
/** 获取库存同步日志 */
export const getInventoryLogs = businessTimezoneTranslate(
  async (data: Types.StockSyncLogListReqDTO) => http.admin.post<Types.LogListRes>('/api/stock/sync/log/list', data),
  ['syncStartTime', 'syncEndTime'],
  ['data.list.[].syncTime']
)
/** 获取试算结果 */
export const getTrialList = async (data) => http.admin.post(stockUrl.trialList, data)
/** 获取支持上传库存销售平台列表 */
export const getPlatformList = async () => http.admin.get(stockUrl.platformList)
/** 库存试算 */
export const stockTrial = async (data) => http.admin.post<Types.TryCalculateV2Res>(stockUrl.stockTrial, data)
/** 提交库存同步任务 */
export const submitSyncStockTask = async (data) => http.admin.post(stockUrl.submitSyncStockTask, data)
/** 重试：库存同步 */
export const retrySyncStockTask = async (data) => http.admin.post(stockUrl.retrySyncStockTask, data)

/** 单个库存调整 */
export const stocksChange = async (data: Types.StocksChangeReq) => http.admin.post(stockUrl.stocksChange, data)

/** 批量库存调整 */
export const stocksBatchChange = async (data: Types.StockBatchChangeReq) => http.admin.post(stockUrl.stocksBatchChange, data)

/** 库存列表 */
export const stocksList = businessTimezoneTranslate(
  async (data: Types.StocksSearchReq) => http.admin.post<Types.StocksSearchRes>('/api/stocks/search', data),
  [],
  ['data.list.[].stockBatch.[].actionTime', 'data.list.[].stockBatch.[].expireWarnDate']
)

export const allStocksList = businessTimezoneTranslate(
  async (data: Types.SearchAllStockRequest) => http.admin.post<Types.StocksSearchRes>('/api/stocks/all/search', data),
  [],
  ['data.list.[].stockBatch.[].actionTime', 'data.list.[].stockBatch.[].expireWarnDate']
)

export const updateSafetyStock = async (data: Types.SellerSafetyStockUpdateReq) => http.admin.post(stockUrl.updateSafetyStock, data)

export const batchUpdateSafetyStock = async (data: Types.SellerSafetyStockBatchUpdateReq) => http.admin.post(stockUrl.batchUpdateSafetyStock, data)

export const totalSafetyStockEditable = async () =>
  http.admin.post<{
    editable?: boolean
  }>(stockUrl.totalSafetyStockEditable)

export const getSafetyStockSettings = async () => http.admin.post<Types.SafetyStockSetting>(stockUrl.getSafetyStockSettings)

export const updateSinglesSafetyStock = async (data: Types.UpdateSinglesSafetyStockReq) => http.admin.post(stockUrl.updateSinglesSafetyStock, data)

export const updateTotalSafetyStock = async (data: Types.TotalSafetyStockSetting) => http.admin.post(stockUrl.updateTotalSafetyStock, data)

export const clearSafetyStockSettings = async (data: { type: Types.StockType }) => http.admin.post(stockUrl.clearSafetyStockSettings, data)

/**  */
export const getExpireDateSummary = async (data: Types.StockSummaryExpireDateReqDTO) => http.admin.post<Types.SummaryRes>('/api/stocks/expire_date/summary', data)

/**分页查询库存流水列表 */
export const stockFlowPage = businessTimezoneTranslate(
  (params) => http.admin.post('/api/stocks/stock-flow/page', params),
  ['startTime', 'endTime'],
  ['data.list.[].createTime', 'data.list.[].actionTime', 'data.list.[].changeInfo.inboundDate']
)
